import styled from "styled-components";
import Button from "components/base/Button";

// #####################################################

export const StyledCloseButton = styled(Button)`
	position: absolute;
	top: 1rem;
	right: 1rem;
	font-size: 2rem;
	line-height: 2rem;
	text-shadow: 0 1px 0 #fff;
	z-index: 2002;

	svg {
		color: rgba(255, 255, 255, 0.65);
	}

	&:hover {
		svg {
			color: rgba(255, 255, 255, 0.95);
		}
	}
`;

// #####################################################
